document.addEventListener("DOMContentLoaded", function () {
  "use strict";

  var CLS_ACTIVE =
    "awards-tab-btn font-neutraface text-[1.25rem] leading-[1.563rem] px-5 py-2 rounded-full transition-all duration-200 text-white bg-brand-dark-red";
  var CLS_INACTIVE =
    "awards-tab-btn font-neutraface text-[1.25rem] leading-[1.563rem] px-5 py-2 rounded-full transition-all duration-200 border bg-transparent text-brand-dark-blue border-brand-dark-blue";
  var CLS_DROPDOWN_ACTIVE =
    "awards-tab-btn awards-dropdown-item px-4 py-2 block cursor-pointer !no-underline font-neutraface text-[1.25rem] leading-[1.563rem] transition-all duration-200 bg-brand-dark-red text-white";
  var CLS_DROPDOWN_INACTIVE =
    "awards-tab-btn awards-dropdown-item px-4 py-2 block cursor-pointer !no-underline font-neutraface text-[1.25rem] leading-[1.563rem] transition-all duration-200 text-brand-black bg-transparent hover:bg-brand-dark-red hover:text-white";
  var CLS_HEADING = "awards-heading text-center mb-6";

  function initAwardsBlock(section) {
    var blockId = section.id;
    if (!blockId) return;

    var heading = document.getElementById(blockId + "-heading");
    var headingTitle = heading
      ? heading.querySelector(".awards-heading__title")
      : null;
    var headingDesc = heading
      ? heading.querySelector(".awards-heading__desc")
      : null;

    var tabs = section.querySelectorAll(
      '.awards-tab-btn[data-block="' +
        blockId +
        '"]:not(.awards-dropdown-item)',
    );

    var dropdownItems = section.querySelectorAll(
      '.awards-dropdown-item[data-block="' + blockId + '"]',
    );
    var panels = section.querySelectorAll(".awards-tab-panel");

    var mobileDropdown = document.getElementById(blockId + "-mobile-dropdown");
    var dropdownToggle = mobileDropdown
      ? mobileDropdown.querySelector(".awards-dropdown-toggle")
      : null;
    var dropdownMenu = mobileDropdown
      ? mobileDropdown.querySelector(".awards-dropdown-menu")
      : null;
    var dropdownLabel = mobileDropdown
      ? mobileDropdown.querySelector(".awards-dropdown-label")
      : null;
    var dropdownArrow = mobileDropdown
      ? mobileDropdown.querySelector(".awards-dropdown-arrow")
      : null;

    if (!tabs.length && !dropdownItems.length) return;

    if (dropdownToggle && dropdownMenu) {
      dropdownToggle.addEventListener("click", function () {
        var isOpen = !dropdownMenu.classList.contains("hidden");
        dropdownMenu.classList.toggle("hidden", isOpen);
        if (dropdownArrow) {
          dropdownArrow.style.transform = isOpen
            ? "rotate(0deg)"
            : "rotate(180deg)";
        }
      });

      document.addEventListener("click", function (e) {
        if (mobileDropdown && !mobileDropdown.contains(e.target)) {
          dropdownMenu.classList.add("hidden");
          if (dropdownArrow) dropdownArrow.style.transform = "rotate(0deg)";
        }
      });
    }

    function activateTab(targetPanelId) {
      tabs.forEach(function (t) {
        var active = t.dataset.tabTarget === targetPanelId;
        var color = t.dataset.termColor;

        t.setAttribute("aria-selected", active ? "true" : "false");
        t.className = active ? CLS_ACTIVE : CLS_INACTIVE;

        if (active && heading) {
          updateHeading(t.dataset.termName, color, t.dataset.termDescHtml);
        }
      });

      dropdownItems.forEach(function (item) {
        var active = item.dataset.tabTarget === targetPanelId;
        item.className = active ? CLS_DROPDOWN_ACTIVE : CLS_DROPDOWN_INACTIVE;

        if (active) {
          if (dropdownLabel)
            dropdownLabel.textContent = item.dataset.termName || "";
          updateHeading(
            item.dataset.termName,
            item.dataset.termColor,
            item.dataset.termDescHtml,
          );
        }
      });

      panels.forEach(function (p) {
        p.classList.toggle("hidden", p.id !== targetPanelId);
      });
    }

    function updateHeading(name, color, descHtml) {
      if (!heading) return;
      if (headingTitle) {
        headingTitle.textContent = name || "";
        headingTitle.className =
          "awards-heading__title font-neutraface font-semibold text-h2 mb-3 text-" +
          color;
      }
      heading.setAttribute("class", CLS_HEADING);
      if (headingDesc) {
        headingDesc.innerHTML = descHtml || "";
        headingDesc.classList.toggle("hidden", !(descHtml || "").trim());
      }
    }

    var hashId = window.location.hash ? window.location.hash.slice(1) : null;
    var restored = false;

    if (hashId) {
      tabs.forEach(function (t) {
        if (!restored && t.dataset.termSlug === hashId) {
          activateTab(t.dataset.tabTarget);
          restored = true;
        }
      });

      if (!restored) {
        dropdownItems.forEach(function (item) {
          if (!restored && item.dataset.termSlug === hashId) {
            activateTab(item.dataset.tabTarget);
            restored = true;
          }
        });
      }
    }

    if (!restored) {
      var firstTab = tabs[0] || dropdownItems[0];
      if (firstTab) activateTab(firstTab.dataset.tabTarget);
    }

    if (restored) {
      setTimeout(function () {
        section.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function (e) {
        e.preventDefault();
        var panelId = tab.dataset.tabTarget;
        var termSlug = tab.dataset.termSlug;
        activateTab(panelId);
        if (termSlug && window.history && window.history.pushState) {
          window.history.pushState({ tabPanelId: panelId }, "", "#" + termSlug);
        }
        section.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });

    dropdownItems.forEach(function (item) {
      item.addEventListener("click", function (e) {
        e.preventDefault();
        var panelId = item.dataset.tabTarget;
        var termSlug = item.dataset.termSlug;
        activateTab(panelId);

        if (dropdownMenu) dropdownMenu.classList.add("hidden");
        if (dropdownArrow) dropdownArrow.style.transform = "rotate(0deg)";

        if (termSlug && window.history && window.history.pushState) {
          window.history.pushState({ tabPanelId: panelId }, "", "#" + termSlug);
        }
        section.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });

    window.addEventListener("popstate", function (e) {
      if (e.state && e.state.tabPanelId) {
        activateTab(e.state.tabPanelId);
      }
    });
  }

  document
    .querySelectorAll('[data-testid="section-awards"]')
    .forEach(function (section) {
      initAwardsBlock(section);
    });
});
